

































































































































































































import { ActionMethod } from "vuex";
import BaseFilter from "@/components/Filter/BaseFilter";
import {FilterSelectedItemWings} from "wings-ui-components";
import { Component, PropSync, Watch } from "vue-property-decorator";
import { DatePickerWings, FastDateGroupWings, SelectWings, NumberWings } from "wings-ui-components";
import { beginningOfCurrentDay, currentDate, dateFilter } from "@/utils/date-util";
import { Action, Getter, Mutation } from "vuex-class";
import { WhatsappGroupFilterParams } from "@/store/whatsapp/statistic/types";
import { notifyError, notifyWarning } from "@/utils/notify-helper";
import { OriginatorItem } from "@/store/settings/originators/types";
import { ServiceProviderItem } from "@/store/settings/service_providers/types";
import { PartnerItem } from "@/store/settings/partners/types";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {SelectWings, DatePickerWings, FastDateGroupWings, NumberWings},
  filters: {dateFilter}
})
export default class WhatsappGroupFilter extends BaseFilter<WhatsappGroupFilterParams> {
  @PropSync("show") is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;

  @Mutation('setWhatsappStatisticGroup') setStatistic: any

  @Getter("whatsappGroupBy") groupByList!: string[];
  @Getter("whatsappGroupByOptionally") groupByOptionallyList!: string[];
  @Getter("messageCategories") messageCategoriesList!: any[];
  @Getter("messageTypes") messageTypesList: any;

  @Action("getWhatsappStatisticGroup") actionGetItems!: ActionMethod;
  @Action("exportWhatsappStatisticGroup") actionExport!: ActionMethod;
  @Action("getOriginators") actionGetOriginators!: ActionMethod;
  @Action("getServiceProviders") actionGetServiceProviders!: ActionMethod;
  @Action("getPartners") actionGetPartners!: ActionMethod;
  @Action("getMessageCategories") actionGetMessageCategories!: ActionMethod;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;

  defaultFilter(): WhatsappGroupFilterParams {
    return new WhatsappGroupFilterParams(beginningOfCurrentDay(), currentDate(), "day");
  }

  params = {transport: MsgTransports.WHATSAPP};
  partnersList: any = [];
  originatorsList: any = [];
  accountsList: any = []
  serviceProvidersList:  any = []

  group_by = null;
  group_by_optionally = null;

  filterKeys: object = {
    "originator" : "addresser",
    "broker_account_login" : "broker_account"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({...this.params, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created(): Promise<void> {
    this.setStatistic(null)
    this.parseGroupBy()
    try {
      this.actionGetMessageCategories(this.params);
      this.actionGetMessageTypes();
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
    if (this.filter.service_provider) this.serviceProvidersList = await this.actionGetServiceProviders({name: this.filter.service_provider});
  }

  async onFilteredAction(): Promise<void> {
    this.setStatistic(null);
    this.mergeGroupBy();
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Group statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        notifyWarning();
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  async doActionExport(): Promise<any> {
    this.mergeGroupBy();
    return await this.actionExport(this.sendFilter);
  }

  mergeGroupBy() {
    this.filter.group_by = [this.group_by, this.group_by_optionally].filter(item => item).join(',');
    this.$set(this.sendFilter, 'group_by', this.filter.group_by);
    this.$emit('onGroupByChange', {groupBy: this.group_by, optionallyGroupBy: this.group_by_optionally});
  }

  parseGroupBy() {
    if (this.filter.group_by.length == 0) return

    this.filter.group_by.split(',').forEach((item:any) => {
      if (this.groupByList.includes(item)) this.group_by = item;
      else this.group_by_optionally = item;
    })
  }

  @Watch("filter", { immediate: true, deep: true })
  onFilterChanged(newVal: WhatsappGroupFilterParams) {
    this.propFilterClone = newVal;
  }
}
